import { yupResolver } from '@hookform/resolvers/yup';

import yup from 'utils/yup-form-validator';

const schema = yup.object({
  token: yup.string().isJWT().required(),
});

const validator = yupResolver(schema);

export default validator;
